import type { SVGProps } from "react";

export const ENSAdminIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28" {...props}>
    <path fill="#C2D6FF" d="M2 2h24v24H2V2Z" />
    <path fill="#709FFF" d="m14 6 12 20H2L14 6Z" />
    <path
      fill="#2C71FB"
      d="M5 21h18l.598 1H4.402L5 21ZM8 16h12l.6 1H7.401L8 16ZM11 11h6l.601 1H10.4l.6-1Z"
    />
    <path
      fill="#000"
      fillRule="evenodd"
      d="M24 2H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2ZM4 0a4 4 0 0 0-4 4v20a4 4 0 0 0 4 4h20a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4H4Z"
      clipRule="evenodd"
    />
  </svg>
);
